import { Capacitor } from '@capacitor/core';

/**
 * فتح إعدادات التطبيق في النظام (iOS/Android) حتى يتمكن المستخدم من تفعيل إذن الموقع.
 * على الويب لا يفتح شيئاً — يُستخدم فقط داخل التطبيق الأصلي.
 * @returns {{ success: boolean, error?: string }}
 */
export async function openAppSettings() {
  if (!Capacitor.isNativePlatform()) {
    return { success: false, error: 'web' };
  }
  try {
    const { NativeSettings, AndroidSettings, IOSSettings } = await import('capacitor-native-settings');
    const result = await NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
    return result?.success ? { success: true } : { success: false, error: result?.error || 'unknown' };
  } catch (e) {
    console.warn('openAppSettings failed:', e);
    return { success: false, error: e?.message || 'plugin_unavailable' };
  }
}
